import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// page
import { Kvap0300Component } from './component/kvap0300/kvap0300.component';
import { Kvap0301Component } from './component/kvap0301/kvap0301.component';
import { Kvap0302Component } from './component/kvap0302/kvap0302.component';
import { Kvap0400Component } from './component/kvap0400/kvap0400.component';
import { Kvap0500Component } from './component/kvap0500/kvap0500.component';
import { Kvap0600Component } from './component/kvap0600/kvap0600.component';
import { Kvap0700Component } from './component/kvap0700/kvap0700.component';
import { Kvap0800Component } from './component/kvap0800/kvap0800.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'kvap0302/kvap0300',
    pathMatch: 'full'
  },
  {
    path: 'kvap0302',
    component: Kvap0302Component,
    children: [
      {
        path: 'kvap0300',
        component: Kvap0300Component,
        data: <RouteData>{ title: '担当店一覧', state: 'kvap0300' }
      },
      {
        path: 'kvap0301',
        component: Kvap0301Component,
        data: <RouteData>{ title: '過去日報から事例を見る', state: 'kvap0301' }
      },
    ]
  },
  {
    path: 'kvap0400',
    component: Kvap0400Component,
    data: <RouteData>{ title: '送信済日報一覧', }
  },
  {
    path: 'kvap0500',
    component: Kvap0500Component,
    data: <RouteData>{ title: '担当外店舗検索', }
  },
  {
    path: 'kvap0600',
    component: Kvap0600Component,
    data: <RouteData>{ title: '過去日報一覧', }
  },
  {
    path: 'kvap0700',
    component: Kvap0700Component,
    data: <RouteData>{ title: '過去日報詳細', }
  },
  {
    path: 'kvap0800',
    component: Kvap0800Component,
    data: <RouteData>{ title: '日報報告', }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


/**
 * ルーティング情報
 */
export interface RouteData {
  /** メニュータイトル */
  title?: string;
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts